import { useAuthStore } from '@/stores/authStore';
import { useBookLiquiditySettings } from '@/stores/bookLiquiditySettings';

export function BookLiquiditySettings() {
  const userId = useAuthStore(s => s.user?.id);
  const settings = useBookLiquiditySettings(s => userId ? s.traders[userId] : undefined);
  const update = useBookLiquiditySettings(s => s.update);
  const cap = settings?.cap ?? null;
  return <div className="flex flex-wrap items-center gap-3">
    <label className="flex items-center gap-2 text-xs">
      <input type="checkbox" checked={settings?.enabled ?? false} disabled={!userId || cap === null}
        onChange={e => { if (userId) update(userId, { enabled: e.target.checked, cap }); }} />
      Size to book liquidity
    </label>
    <label className="flex flex-wrap items-center gap-2 text-xs">
      Maximum autofill contracts
      <input type="number" min={1} step={1} value={cap ?? ''} placeholder="Set cap"
        className="border-border bg-input w-28 rounded-md border px-2.5 py-1.5 font-mono text-xs"
        onChange={e => { if (userId) update(userId, { enabled: settings?.enabled ?? false, cap: e.target.value === '' ? null : Number(e.target.value) }); }} />
    </label>
  </div>;
}
